import { create } from 'zustand';

interface UIState {
  /** Desktop-only: collapses the persistent sidebar to an icon rail. */
  sidebarOpen: boolean;
  /** Mobile-only (<lg): controls the slide-over navigation drawer. */
  mobileNavOpen: boolean;
  activeModal: string | null;
  setSidebarOpen: (open: boolean) => void;
  setMobileNavOpen: (open: boolean) => void;
  openModal: (modalId: string) => void;
  closeModal: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  mobileNavOpen: false,
  activeModal: null,
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  setMobileNavOpen: (mobileNavOpen) => set({ mobileNavOpen }),
  openModal: (modalId) => set({ activeModal: modalId }),
  closeModal: () => set({ activeModal: null }),
}));
